import { DashboardState } from "@idw-types/state/dashboard-state";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";
import { DashboardActionTypes, DashboardActions } from "../actions/dashboard-actions";

export const initialDashboardState: DashboardState = {
    searchFilters: {
        companyId: null,
        startDate: getTimeRange(TimeRangeTypes.PAST_TWENTY_FOUR_HOURS).startDate,
        endDate: getTimeRange(TimeRangeTypes.PAST_TWENTY_FOUR_HOURS).endDate,
        timeRangeType: TimeRangeTypes.PAST_TWENTY_FOUR_HOURS
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        summary: null,
        verificationCounts: null,
        verificationServices: null,
        verificationTransactions: null
    }
};

export const dashboardReducer = (
    state: DashboardState = initialDashboardState,
    action: DashboardActions
): DashboardState => {
    switch (action.type) {
        // Search
        case DashboardActionTypes.SET_DASHBOARD_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case DashboardActionTypes.SET_DASHBOARD_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialDashboardState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case DashboardActionTypes.SET_DASHBOARD_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    searchDate: new Date(),
                    ...action.payload.searchResults
                }
            };
        default:
            return state;
    }
};